import React from "react";

interface yScrollerProps {
	children: any;
	className?: string;
	tailClassMinHeight?: string;
	tailClassMaxHeight?: string;
}

const TextYScroller: React.FC<yScrollerProps> = ({
	children,
	className = "",
	tailClassMinHeight = "min-h-0",
	tailClassMaxHeight = ""
}) => {
	const tailwindColor = {
		active: "#f7feff",
		accent: "#29303E",
		inactive: "#5f5766",
		background: "#121929"
	};
	// CSS for webkit scrollbars (needs to be inserted)
	//
	const scrollbarCss = `
    .scrollbar-thin::-webkit-scrollbar {
        width: 6px;
        height: 6px;
    }
    
    .scrollbar-trackColor::-webkit-scrollbar-track {
        background: ${tailwindColor.background};
        border-radius: 3px;
    }
    
    .scrollbar-thumbColor::-webkit-scrollbar-thumb {
        background: ${tailwindColor.active};
        border-radius: 3px;
    }
    
    .scrollbar-thumbHoverColor::-webkit-scrollbar-thumb:hover {
        background: ${tailwindColor.inactive};
    }
  `;

	return (
		<>
			{/* Scrollable container */}
			<div
				className={`overflow-y-auto pr-4
          scrollbar-thin scrollbar-trackColor scrollbar-thumbColor 
          hover:scrollbar-thumbHoverColor ${tailClassMinHeight} ${tailClassMaxHeight} ${className}`}
			>
				<style>{scrollbarCss}</style>

				<div>{children}</div>
			</div>
		</>
	);
};

export default TextYScroller;
